import { getDaysUntil } from './formatters';

/**
 * OS ALERTAS DO DASHBOARD: SÓ O QUE PEDE AÇÃO (decisão A1 do Heitor, 23/10/2026).
 *
 * O cartão dizia "110 · 110 reajustes", e 108 deles eram assinaturas com a data do próximo reajuste no PASSADO: o chute de
 * cadastro de contrato que ninguém conferiu, que nunca anda. Não diziam o que fazer. Agora conta:
 *  - anualidades DEVIDAS (o reajuste é devido e ainda não foi pedido) e PEDIDAS (o ofício saiu, falta a apostila),
 *    lidas das anualidades da assinatura (`contract.adjustments`, que a lista já traz);
 *  - reajuste com data nos próximos 30 dias (não no passado);
 *  - assinatura vencendo em 30 dias e vencida, pelo `contractEndDate` (o `endDate` que se lia não existe).
 * Só assinatura Ativa. As partes não se somam por contrato: cada uma é uma coisa a fazer.
 */
export interface AlertasDoDashboard {
  devidas: number;
  pedidas: number;
  reajusteEm30: number;
  vencendo: number;
  vencidos: number;
  total: number;
  /** As partes não vazias, para o resumo do cartão. */
  partes: string[];
}

const plural = (n: number, um: string, varios: string) => `${n} ${n === 1 ? um : varios}`;

export function alertasQuePedemAcao(contracts: any[]): AlertasDoDashboard {
  const ativos = (contracts || []).filter((c) => c?.status === 'Ativo');
  let devidas = 0;
  let pedidas = 0;
  let reajusteEm30 = 0;
  let vencendo = 0;
  let vencidos = 0;
  for (const c of ativos) {
    for (const a of Array.isArray(c.adjustments) ? c.adjustments : []) {
      if (a?.status === 'devida') devidas++;
      else if (a?.status === 'pedida') pedidas++;
    }
    const dReajuste = c.nextAdjustmentDate ? getDaysUntil(c.nextAdjustmentDate) : null;
    if (dReajuste !== null && dReajuste >= 0 && dReajuste <= 30) reajusteEm30++;
    const dFim = c.contractEndDate ? getDaysUntil(c.contractEndDate) : null;
    if (dFim !== null && dFim > 0 && dFim <= 30) vencendo++;
    else if (dFim !== null && dFim <= 0) vencidos++;
  }
  const partes = [
    devidas > 0 && plural(devidas, 'anualidade devida', 'anualidades devidas'),
    pedidas > 0 && plural(pedidas, 'pedida', 'pedidas'),
    reajusteEm30 > 0 && plural(reajusteEm30, 'reajuste em 30 dias', 'reajustes em 30 dias'),
    vencendo > 0 && plural(vencendo, 'vencendo', 'vencendo'),
    vencidos > 0 && plural(vencidos, 'vencida', 'vencidas'),
  ].filter(Boolean) as string[];
  return { devidas, pedidas, reajusteEm30, vencendo, vencidos, total: devidas + pedidas + reajusteEm30 + vencendo + vencidos, partes };
}
